module.exports = __webpack_public_path__ + "media/customizations/wildryelife/logo-new-a2eaf51d5fd940157585521c88a35448.png";